module.exports = __webpack_public_path__ + "static/img/lead-inter-asset-cleanBg.5426252.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lead-inter-asset-cleanBg.png
// module id = Kq+y
// module chunks = 1